import React from 'react'
import { Dropdown } from './Dropdown'
import { IPaginatedRequest } from '@cbgms/api/request'
import { IPaginatedResponse } from '@cbgms/api/response'

interface IOwnProps<T> {
  DropdownComponent: React.ElementType
  name: string
  label: string
  dropdownProps?: any
  fields: string[]
  search?: string
  selection?: boolean
  action: (params: IPaginatedRequest) => Promise<IPaginatedResponse<T>>
  emptyValue?: any
  emptyLabel?: string
  style?: React.CSSProperties
  autoComplete?: string
  clearButton?: boolean

  text(row: T): string

  value(row: T): string
}

export type KnockFormDropdownProps<T> = IOwnProps<T>

export interface IOptions {
  key: number
  text: string
  value: string
}

export class KnockFormDropdownLogic<T> extends React.Component<KnockFormDropdownProps<T>> {
  state = {
    options: [] as IOptions[],
    isLoading: true
  }

  async loadOptions() {
    const { action, fields, search, text, value } = this.props

    const response = await action({
      fields: fields.toString(),
      perPage: 200,
      search
    })
    this.setState({
      isLoading: false,
      options: this.state.options.concat(
        response.Data.map((item, index) => ({
          key: index,
          text: text(item),
          value: value(item)
        }))
      )
    })
  }

  componentDidMount() {
    this.loadOptions()
  }

  render() {
    const { name, label, dropdownProps, DropdownComponent, selection } = this.props
    const { options, isLoading } = this.state

    return isLoading ? null : (
      <DropdownComponent
        style={{ wordBreak: 'break-all' }}
        name={name}
        label={label}
        {...dropdownProps}
        selection={selection}
        options={options}
        data-testid={`${this.props.name.toLowerCase()}-listbox`}
      />
    )
  }
}

interface IKnockDropdown {
  name: string
  label: string
  options: IOptions[]
  clearButton: boolean
}

const KnockDropdown = ({ name, label, ...rest }: IKnockDropdown) => (
  <Dropdown name={name} label={label} data-testid={`${name.toLowerCase()}-listbox`} {...rest} />
)

export function KnockFormDropdown<T>({ clearButton, emptyValue, ...rest }: Omit<KnockFormDropdownProps<T>, 'DropdownComponent'>) {
  return <KnockFormDropdownLogic {...rest} DropdownComponent={KnockDropdown} dropdownProps={{ clearButton, emptyValue }} />
}
